const heroContent = {
  signin: {
    /* XXX: space at the end IS important */
    description: 'Already gave us your email?',
    url: '/signin',
    cta: 'Resume here',
  },
  returningProspect: {
    title: 'Welcome Back!',
    subtitle:
      'You’re almost finished, just a few more questions to go before you get a customized routine of formulas and products.',
    subtitle2: 'Need to start a new consultation?',
    cta: 'finish your consultation',
    cta2: 'begin',
    showProgressTracker: false,
  },
};

export default heroContent;
